"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = exports.TableRow = exports.TableHeader = exports.TableBody = exports.Table = void 0;
var stitches_config_1 = require("../../../stitches.config");
var Layout_1 = require("../__styles__/Layout");
exports.Table = (0, stitches_config_1.styled)(Layout_1.FlexColumn, {
    "@media print": {
        pageBreakInside: "avoid",
        breakInside: "avoid",
    },
    variants: {
        spacing: {
            negative: {
                margin: "0 -16px",
                "@lg": {
                    margin: "0 -24px",
                },
            },
            positive: {
                paddingTop: "24px",
            },
        },
    },
});
exports.TableBody = (0, stitches_config_1.styled)("div", {
    lineHeight: "20px",
});
exports.TableHeader = (0, stitches_config_1.styled)("div", {});
exports.TableRow = (0, stitches_config_1.styled)(Layout_1.FlexRow, {
    justifyContent: "space-between",
    maxWidth: "100%",
    "> div:first-child": {
        paddingLeft: "16px",
        textAlign: "left",
        "@lg": {
            paddingLeft: "24px",
        },
    },
    "> div:last-child": {
        paddingRight: "16px",
        "@lg": {
            paddingRight: "24px",
        },
    },
    "> div:not(first-child)": {
        textAlign: "right",
    },
    variants: {
        header: {
            true: {
                "> div": {
                    fontWeight: 500,
                    fontSize: "16px",
                    color: stitches_config_1.colors.contentPrimary,
                    paddingBottom: "16px",
                    paddingTop: "0px",
                },
            },
            false: {
                "&:nth-child(even)": {
                    backgroundColor: stitches_config_1.colors.bgUiList,
                },
            },
        },
    },
    defaultVariants: {
        header: false,
    },
});
exports.TableCell = (0, stitches_config_1.styled)("div", {
    padding: "6px 3px",
    flexBasis: "50%",
    a: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    fontSize: "14px",
    lineHeight: "20px",
    whiteSpace: "nowrap",
    "@mdMax": {
        whiteSpace: "unset",
    },
    variants: {
        wrap: {
            true: {
                whiteSpace: "normal",
            },
        },
        size: {
            narrow: {
                paddingRight: "18px",
            },
            wide: {
                paddingRight: "0px",
            },
        },
        containsTooltip: {
            true: {
                display: "flex",
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,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